import React, { memo } from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import ShareIcon from '@material-ui/icons/Share';
import { Modal } from '../../../components/Modal';
import { CopyTextField } from '../../../components/TextField';
import { IconButton } from '../../../components/Button';
import {
  generateExternalMeetingUrl,
  generateMeetingUrl,
} from '../../../helper/conference';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
    copyTextfield: {
      color: theme.palette.secondary.main,
    },
  });
};

export interface IShareMeetingModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: React.MouseEventHandler<HTMLButtonElement>;
  meeting: any;
}

const ShareMeetingModal = ({
  classes,
  open,
  handleClose,
  meeting,
}: IShareMeetingModalProps) => {
  const intl = useIntl();
  const generateEmail = () => {
    const subject = `You have a meeting scheduled on MM for   ${moment(
      meeting?.beginTime
    ).format('YYYY/MM/DD - hh:mm A')} `;
    const message = `Hi,
    
Meeting Topic : ${meeting?.name}
Meeting Created by : ${meeting?.host?.profile?.name} | ${meeting?.host?.email}
Date : ${moment(meeting?.endTime).format('YYYY/MM/DD')}
Time : ${moment(meeting?.beginTime).format('hh:mm A')} - ${moment(
      meeting?.endTime
    ).format('hh:mm A')}
Meeting Link : ${generateMeetingUrl(meeting?.location)}

Please use Google Chrome or other popular supported web browsers to join this meeting. 

Powered by Meetrix`;

    return `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;
  };

  return (
    <Modal
      modalTitle={intl.formatMessage({
        id: 'schedule_meeting',
      })}
      selectedItem={meeting?.name}
      modalDescription={intl.formatMessage({
        id: 'share_meeting_description',
      })}
      open={open}
      handleClose={handleClose}
      actionButtons={
        <IconButton
          href={generateEmail()}
          id="share-button"
          variant="contained"
          label={intl.formatMessage({
            id: 'share_invitation',
          })}
          icon={<ShareIcon />}
        />
      }
    >
      <CopyTextField
        value={generateMeetingUrl(meeting?.location)}
        label={intl.formatMessage({
          id: 'meeting_link',
        })}
        customStyles={classes.copyTextfield}
      />
      <CopyTextField
        value={generateExternalMeetingUrl(meeting?.location, meeting?.jwtToken)}
        label={intl.formatMessage({
          id: 'external_meeting_link',
        })}
        customStyles={classes.copyTextfield}
      />
    </Modal>
  );
};

export default memo(withStyles(styles)(ShareMeetingModal));
